import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'

export default {
    async fetchAll(query, filters) {
        return await axios.get(`payment?q=${query}&` + buildQuery(filters),{
            headers: {
                'Content-Encoding': 'gzip',
              }
        })
    },
    async fetchByPermission() {
        return await axios.get(`payment/fetchby/permission`)
    },
    async create(model) {
        return await axios.post(`payment`, model)
    },
    async fetchById(id) {
        return await axios.get(`payment/${id}`)
    },

    async update(id, model) {
        return await axios.put(`payment/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`payment/${id}`)
    },

    async fetchActivityTransactions(query, filters) {
        return await axios.get(`payment/activity-transactions?q=${query}&` + buildQuery(filters),{
            headers: {
                'Content-Encoding': 'gzip',
              }
        })
    },
    async fetchorder() {
        return await axios.get(`payment/activity`)
    },

    async fetchcustomer(){
        return await axios.get(`payment/customer`)
    },

    async fetchBank(){
        return await axios.get(`payment/bank`)
    },

    async exportExcel(query, filters,exportExcel){
        return await axios.get(`payment?q=${query}&export_csv=${exportExcel}&` + buildQuery(filters),{
            responseType: 'blob'
        })
    },
    async exportExcelOrderTransaction(query, filters,exportExcel){
        return await axios.get(`payment/activity-transactions?q=${query}&export_csv=${exportExcel}&` + buildQuery(filters),{
            responseType: 'blob'
        })
    }
}
